<template>
  <div v-if="$store.state.user" class="projects">
    <!-- Loading timer discreto -->
    <v-fade-transition>
      <div v-if="loading" class="discrete-loader">
        <v-progress-circular indeterminate color="primary" size="16" width="2"></v-progress-circular>
        <span class="ml-2 text-caption">{{ loadingTime }}</span>
      </div>
    </v-fade-transition>

    <v-card class="main-card pa-6 mb-6">
      <v-data-table
          :headers="choiceAlert"
          :items="projects || []"
          :options.sync="dtOptions"
          :server-items-length="projectsCount"
          :loading="loading"
          loading-text=""
          hide-default-footer
          :items-per-page="50"
          class="table-fade-in"
          @item-expanded="loadDetails"
          light
          show-expand
          :expanded.sync="expandedClose"
          :item-class="getRowClass"
      >
      <template v-slot:top>
        <v-col class="px-0 pt-0">
          <div class="d-flex align-center mb-4">
            <h2 class="text-h5 font-weight-medium primary--text">{{ projectsCount }} Progetti</h2>
            <v-progress-circular
              v-if="loading"
              indeterminate
              color="primary"
              size="16"
              width="2"
              class="ml-3"
            ></v-progress-circular>
            <v-spacer></v-spacer>
            <v-btn
                v-if="$store.getters.isAdmin || $store.getters.isHead"
                color="primary"
                class="mr-2"
                text
                @click="addProject">
              <v-icon left>mdi-plus</v-icon>
              Nuovo progetto
            </v-btn>
            <v-btn
                v-if="$store.getters.isAdmin || $store.getters.isPurchaseOperator || $store.getters.isHead"
                color="primary"
                text
                @click="closeAll"
            >
              <v-icon left>mdi-arrow-collapse-all</v-icon>
              Chiudi tutti
            </v-btn>
          </div>
        </v-col>
        <v-card class="pa-4 mb-4 mx-0 filter-section" elevation="1">
          <div class="d-flex align-center mb-4 flex-wrap">
            <div class="d-flex align-center">
              <v-icon :color="filtersActive ? 'success' : 'primary'" size="18" class="mr-2">{{ filtersActive ? 'mdi-filter-check' : 'mdi-filter' }}</v-icon>
              <span class="text-subtitle-2 font-weight-medium">Filtri</span>
              <v-progress-circular
                v-if="filterLoading"
                indeterminate
                color="primary"
                size="16"
                width="2"
                class="ml-2"
              ></v-progress-circular>
            </div>

            <v-switch
                dense
                v-model="filterForAlert"
                label="Solo con Alert"
                color="error"
                false-value=""
                hide-details
                class="ml-4 my-0"
                inset
                @change="debounceFilter"
            ></v-switch>

            <v-switch
                dense
                v-model="excludeSecondary"
                label="Escludi Secondari"
                color="primary"
                false-value=""
                hide-details
                class="ml-4 my-0"
                inset
                @change="debounceFilter"
            ></v-switch>

            <v-spacer></v-spacer>

            <div class="d-flex align-center">
              <v-btn
                :color="filtersActive ? 'error' : 'primary'"
                :text="!filtersActive"
                :outlined="filtersActive"
                small
                @click="resetFilters"
                class="mr-2 px-2"
              >
                <v-icon small left>mdi-refresh</v-icon>
                Reset
              </v-btn>
              <v-btn
                color="success"
                :text="!filtersActive"
                :outlined="filtersActive"
                small
                @click="applyFilters"
                class="px-2"
              >
                <v-icon small left>mdi-filter-check</v-icon>
                Applica
              </v-btn>
            </div>
          </div>
          <v-divider class="mb-4"></v-divider>
          <v-row class="filter-row">
            <v-col cols="12" sm="6" md="4" xl="2" class="py-2">
              <if65-select
                  v-model="selectedCustomerId"
                  :api="$customerService.list"
                  :extra-params="prependExtraParams"
                  label=""
                  placeholder="Seleziona insegna..."
                  dense
                  clearable
                  flat
                  solo
                  @input="onCustomerSelect"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" xl="2" class="py-2">
              <if65-autocomplete
                  v-model="customIdToSearch"
                  :api="$projectService.list_ids"
                  :extra-params="prependExtraParams"
                  label="Cerca ID progetto..."
                  dense
                  clearable
                  flat
                  solo
                  @input="debounceFilter"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" xl="2" class="py-2">
              <if65-autocomplete
                  v-model="projectToSearch"
                  :api="$projectService.list_names"
                  :extra-params="prependExtraParams"
                  label="Cerca progetto..."
                  dense
                  clearable
                  flat
                  solo
                  @input="debounceFilter"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" xl="2" class="py-2" v-if="['ADMIN', 'HEAD'].includes($store.state.user.role)">
              <if65-select
                  v-model="operatorIdToSearch"
                  :api="$userService.list"
                  :extra-params="prependExtraParams"
                  label=""
                  placeholder="Seleziona operatore..."
                  dense
                  clearable
                  flat
                  solo
                  @input="debounceFilter"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" xl="2" class="py-2">
              <if65-select
                  v-model="statusToSearch"
                  :api="$productService.status_choices"
                  :extra-params="prependExtraParams"
                  label=""
                  placeholder="Seleziona stato..."
                  dense
                  clearable
                  flat
                  solo
                  @input="debounceFilter"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" xl="2" class="py-2">
              <if65-select
                  v-model="annoDiRiferimento"
                  :api="$projectService.list_years"
                  :extra-params="prependExtraParams"
                  label=""
                  placeholder="Seleziona anno..."
                  dense
                  clearable
                  flat
                  solo
                  @input="debounceFilter"
              />
            </v-col>
          </v-row>

        </v-card>
      </template>
      <template #item.customer_name="{ item }">
        <div class="insegna-text">
          {{ item.customer_name }}
        </div>
      </template>

      <template #item.custom_id="{ item }">
        <div class="cid-text">
          {{ item.custom_id }}
        </div>
      </template>

      <template #item.name="{ item }">
        <span class="font-weight-medium">
          {{ item.name }}
        </span>
      </template>
      <template v-slot:item.show_expiration_alert="{ item }" v-if="$store.getters.isAdmin || $store.getters.isHead || $store.getters.isPurchaseOperator">
        <a
            v-if="item.show_alert && item.show_alert.length > 0"
            @click="openInfoAlert(item)"
        >
          <v-badge
              overlap
              :content="item.show_alert.length"
              bordered
              color="if65Red"
          >
            <v-icon small>mdi-bell</v-icon>
          </v-badge>
        </a>
      </template>
      <template v-slot:item.show_alert="{ item }"
                v-if="['WEB_OPERATOR', 'GRAPHIC_OPERATOR'].includes($store.state.user.role)">
        <a
            v-if="item.show_expiration_alert"
            @click="openInfoAlert(item)"
        >
          <v-badge
              v-if="item.show_alert.length > 0"
              overlap
              :content="item.show_alert.length"
              bordered
              color="red darken-1"
          >
            <v-icon small color="if65Silver">mdi-bell</v-icon>
          </v-badge>
        </a>
      </template>
      <template v-slot:item.owner_full_name="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-chip
                color="primary"
                small
                class="white--text elevation-1 ref-chip"
                v-if="item.owner_full_name === 'Francesca Amministratore'"
              >
                {{ initialOperator(item.owner_full_name) }}
              </v-chip>
              <v-chip
                color="error"
                small
                class="white--text elevation-1 ref-chip"
                v-else
              >
                {{ initialOperator(item.owner_full_name) }}
              </v-chip>
            </span>
          </template>
          {{ item.owner_full_name }}
        </v-tooltip>
      </template>
      <template v-slot:item.data_promozione_dal="{item}">
        <template v-if="item.data_promozione_dal">
          <v-chip small color='primary' class="font-weight-medium date-chip white--text">{{ formatDate(item.data_promozione_dal) }}</v-chip>
        </template>
        <template v-else>
          <span class="date-empty">-</span>
        </template>
      </template>
      <template v-slot:item.data_promozione_al="{item}">
        <template v-if="item.data_promozione_al">
          <v-chip small color='primary' outlined class="font-weight-medium date-chip">{{ formatDate(item.data_promozione_al) }}</v-chip>
        </template>
        <template v-else>
          <span class="date-empty">-</span>
        </template>
      </template>
      <template v-slot:item.data_sottocosto_dal="{item}">
        <template v-if="item.data_sottocosto_dal">
          <v-chip small color='success' class="font-weight-medium date-chip white--text">{{ formatDate(item.data_sottocosto_dal) }}</v-chip>
        </template>
        <template v-else>
          <span class="date-empty">-</span>
        </template>
      </template>
      <template v-slot:item.data_sottocosto_al="{item}">
        <template v-if="item.data_sottocosto_al">
          <v-chip small color='success' outlined class="font-weight-medium date-chip">{{ formatDate(item.data_sottocosto_al) }}</v-chip>
        </template>
        <template v-else>
          <span class="date-empty">-</span>
        </template>
      </template>
      <!--            <template v-slot:item.activities_progress="{ item }">-->
      <!--              <v-chip small :color="item.activities_progress[0] === item.activities_progress[1] ? 'teal lighten-4': 'gray'">{{ item.activities_progress[0] }} di {{ item.activities_progress[1] }}</v-chip>-->
      <!--            </template>-->
      <template v-slot:item.anno_riferimento="{item}">
        <v-chip small :color="getColor(item.anno_riferimento)" outlined class="font-weight-medium anno-chip">{{ item.anno_riferimento }}</v-chip>
      </template>
      <template #item.actions="{ item }">
        <div class="table-actions">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  x-small
                  color="primary"
                  @click="openProjectDetail(item)"
              >
                <v-icon small>mdi-list-status</v-icon>
              </v-btn>
            </template>
            <span>Visualizza Attività</span>
          </v-tooltip>

          <v-tooltip top v-if="$store.getters.isAdmin || $store.getters.isPurchaseOperator">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  x-small
                  color="primary"
                  @click="editProject(item)"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Modifica Progetto</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  x-small
                  color="primary"
                  @click="$router.push({ name: 'tasksProject2', params: { projectId: item.id } })"
              >
                <v-icon small>{{ tasksIcon }}</v-icon>
              </v-btn>
            </template>
            <span>Visualizza Tasks</span>
          </v-tooltip>

          <v-tooltip top v-if="$store.getters.isAdmin || $store.getters.isPurchaseOperator || $store.getters.isHead">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  x-small
                  color="primary"
                  @click="cloneProject(item)"
              >
                <v-icon small>mdi-arrange-send-backward</v-icon>
              </v-btn>
            </template>
            <span>Clona Progetto</span>
          </v-tooltip>

          <v-tooltip top v-if="$store.getters.isAdmin">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  x-small
                  color="error"
                  @click="deleteProject(item)"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Elimina Progetto</span>
          </v-tooltip>
        </div>
      </template>
      <template v-if="$store.getters.canViewExpansion"
                v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="expanded-row-container">
          <!-- Separatore visivo -->
          <div class="expanded-separator"></div>

          <!-- Header della sezione espansa -->
          <div class="expanded-header">
            <v-icon color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
            <span class="font-weight-medium primary--text">Dettagli Progetto: {{ item.name }}</span>
          </div>

          <!-- Contenuto espanso -->
          <v-card flat class="detail-card-improved">
            <list-details :id="expanded" :project-code="item.custom_id" :status-to-search="statusToSearch"></list-details>
          </v-card>
        </td>
      </template>
    </v-data-table>

    <custom-pagination
        v-model="dtOptions.page"
        :total-items="projectsCount"
        :items-per-page="dtOptions.itemsPerPage || 10"
        @update:items-per-page="updateItemsPerPage"
        @page-changing="onPageChanging"
    ></custom-pagination>
    </v-card>
    <!-- Modali -->
    <project-dialog
        v-if="showProjectDialog"
        v-model="showProjectDialog"
        :project-id="selectedProjectId"
        :clone="clone"/>
    <project-delete-dialog
        v-if="showProjectDeleteDialog"
        v-model="showProjectDeleteDialog"
        :project-id="projectIdToDelete"
        @confirmed="loadProjects()"/>
    <project-detail-modal
        v-model="showProjectDetailModal"
        :project-id="selectedProjectId"/>
    <v-dialog
        v-model="openAlert"
        width="900">
      <v-card class="white">
        <v-card-title class="text-h5 primary--text">
          <v-icon color="error" class="mr-2">mdi-bell</v-icon>
          Prodotti in scadenza: {{ detailAlert.length }}
        </v-card-title>

        <v-card-text class="mt-4">
          <v-data-table
              :headers="headersDetailAlert"
              :items="detailAlert"
              class="table-fade-in"
          >
            <template #item.name="{item}">
              <router-link to="/projects"><span style="text-decoration: 2px underline dotted">{{ item.name }}</span>
              </router-link>
            </template>
            <template #item.delivery_date="{item}">
              {{ formatDate(item.delivery_date) }}
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="openAlert = false"
          >
            <v-icon left>mdi-close</v-icon>
            Chiudi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ProjectDeleteDialog from "./ProjectDeleteDialog.vue";
import ProjectDialog from "../../components/ProjectDialog.vue";
import ProjectDetailModal from "../../components/ProjectDetailModal.vue";
import ProjectService from "../../services/project.service.js";
import ListDetails from "../../components/ProjectDetail/ListDetails";
import If65Select from "../../components/widgets/If65Select";
import If65Autocomplete from "../../components/widgets/If65Autocomplete";
import CustomPagination from "../../components/widgets/CustomPagination";
import moment from "moment";
import 'moment/locale/it'

export default {
  components: {
    ProjectDeleteDialog,
    ProjectDialog,
    ProjectDetailModal,
    ListDetails,
    If65Select,
    If65Autocomplete,
    CustomPagination,
  },
  data: () => ({
    filterLoading: false, // Stato di caricamento dei filtri
    filterTimeout: null, // Timeout per il debounce dei filtri
    isInitializing: true, // Flag per evitare chiamate duplicate durante l'inizializzazione
    headers: [],
    headersDetailAlert: [
      {text: 'ID', value: 'id', class: 'text-dark'},
      {text: 'Nome Prodotto', value: 'name', class: 'text-dark'},
      {text: 'Scadenza', value: 'delivery_date', class: 'text-dark'},
      {text: 'Stato', value: 'status', class: 'text-dark'},
    ],
    projectToSearch: '',
    customIdToSearch: '',
    customerToSearch: '',
    selectedCustomerId: null, // ID del cliente selezionato
    operatorIdToSearch: '',
    statusToSearch: '',
    annoDiRiferimento: '',
    projects: null,
    projectId: null,
    dtOptions: {
      itemsPerPage: 50
    },
    projectsCount: 0,
    loading: false,  // Iniziamo con false per evitare overlay all'apertura della pagina
    projectIdToDelete: null,
    clone: false,
    selectedProjectId: null,
    showProjectDialog: false,
    showProjectDeleteDialog: false,
    showProjectDetailModal: false,
    expanded: null,
    expandedClose: [],
    snackbar: false,
    infoSnackbar: null,
    progress: false,
    // Modal
    openAlert: false,
    detailAlert: [],
    // Filter&search
    filterForAlert: null,
    excludeSecondary: true,
    // Loading timer
    loadingStartTime: null,
    loadingTime: "0.00s",
    loadingTimer: null
  }),
  computed: {
    yearFromUrl() {
      return this.$route.params.anno_riferimento || null
    },
    isBackup() {
      // Per i purchase_operator, forza sempre is_backup = 1 per vedere tutti i progetti
      if (this.$store.getters.isPurchaseOperator) {
        return 1;
      }
      return this.yearFromUrl !== null ? 1 : 0;
    },
    choiceAlert() {
      if (this.$store.getters.isAdmin || this.$store.getters.isPurchaseOperator || this.$store.getters.isHead) {
        return [
          {
            value: 'show_expiration_alert',
            text: '',
            sortable: false,
            width: '40px',
            align: 'center',
            class: 'alert-column',
          },
          {
            value: 'owner_full_name',
            text: 'Refer.',
            sortable: true,
            width: '70px',
            align: 'center',
            class: 'referente-column',
          },
          {
            value: 'customer_name',
            text: 'Insegna',
            sortable: true,
            width: '140px',
            class: 'insegna-column',
          },
          {
            value: 'custom_id',
            text: 'CID',
            sortable: true,
            width: '100px',
            class: 'cid-column',
          },
          {
            value: 'name',
            text: 'Progetto',
            sortable: false,
            class: 'progetto-column',
            width: '300px',
          },
          {
            value: 'data_promozione_dal',
            text: 'Promozione Da',
            sortable: false,
            width: '120px',
            class: 'date-column-from',
          },
          {
            value: 'data_promozione_al',
            text: 'Promozione A',
            sortable: false,
            width: '120px',
            class: 'date-column-to',
          },
          {
            value: 'data_sottocosto_dal',
            text: 'Sottocosto Da',
            sortable: false,
            width: '120px',
            class: 'date-column-from',
          },
          {
            value: 'data_sottocosto_al',
            text: 'Sottocosto A',
            sortable: false,
            width: '120px',
            class: 'date-column-to',
          },
          {
            value: 'anno_riferimento',
            text: 'Anno',
            sortable: true,
            width: '80px',
            class: 'anno-column',
          },
          {
            value: 'actions',
            text: 'Azioni',
            sortable: false,
            align: 'end',
            width: '170px',
            class: 'actions-column',
          },
          {
            text: "",
            sortable: false,
            width: "50px",
            value: "data-table-expand",
            class: "expand-column"
          },
        ]
      } else {
        {
          return [
            {
              value: 'show_alert',
              text: '',
              sortable: false,
              width: '40px',
              align: 'center',
              class: 'alert-column',
            },
            {
              value: 'owner_full_name',
              text: 'Refer.',
              sortable: true,
              width: '70px',
              align: 'center',
              class: 'referente-column',
            },
            {
              value: 'customer_name',
              text: 'Insegna',
              sortable: true,
              width: '140px',
              class: 'insegna-column',
            },
            {
              value: 'custom_id',
              text: 'CID',
              sortable: true,
              width: '100px',
              class: 'cid-column',
            },
            {
              value: 'name',
              text: 'Progetto',
              sortable: false,
              class: 'progetto-column',
              width: '300px',
            },
            {
              value: 'data_promozione_dal',
              text: 'Promozione Da',
              sortable: false,
              width: '120px',
              class: 'date-column-from',
            },
            {
              value: 'data_promozione_al',
              text: 'Promozione A',
              sortable: false,
              width: '120px',
              class: 'date-column-to',
            },
            {
              value: 'data_sottocosto_dal',
              text: 'Sottocosto Da',
              sortable: false,
              width: '120px',
              class: 'date-column-from',
            },
            {
              value: 'data_sottocosto_al',
              text: 'Sottocosto A',
              sortable: false,
              width: '120px',
              class: 'date-column-to',
            },
            {
              value: 'anno_riferimento',
              text: 'Anno',
              sortable: true,
              width: '80px',
              class: 'anno-column',
            },
            {
              value: 'actions',
              text: 'Azioni',
              sortable: false,
              align: 'end',
              width: '170px',
              class: 'actions-column',
            },
            {
              text: "",
              sortable: false,
              width: "50px",
              value: "data-table-expand",
              class: "expand-column"
            },
          ]
        }
      }
    },
    prependExtraParams() {
      return this.projectId ? {project: this.projectId, choices: ''} : {choices: ''}
    },
    tasksIcon() {
      return this.$icons.task
    },
    ordering() {
      const {sortBy, sortDesc, page, pagePerItem} = this.dtOptions
      console.log(page, pagePerItem)
      if (sortBy && sortDesc && sortBy.length === 1 && sortDesc.length === 1) {
        return {ordering: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`}
      }
      return {}
    },
    showAlert() {
      return this.projects.filter(items => {
        return items.show_expiration_alert === true
      })
    },
    // Proprietà calcolata per verificare se i filtri sono attivi
    filtersActive() {
      return this.hasActiveFilters();
    }
  },
  watch: {
    dtOptions: {
      handler() {
        // Evita chiamate duplicate durante l'inizializzazione
        if (this.isInitializing) {
          return;
        }

        // Utilizziamo loadProjectsFiltered solo se ci sono filtri attivi
        if (this.hasActiveFilters()) {
          this.filterLoading = true;
          this.loadProjectsFiltered();
        } else {
          this.loading = true;
          this.loadProjects();
        }
      },
      deep: true,
    },
    // Rimuoviamo i watcher per i filtri poiché ora utilizziamo debounceFilter
    // customerToSearch() {
    //   this.loadProjects()
    // },
    // customIdToSearch() {
    //   if (this.customIdToSearch.length >= 2) {
    //     this.loading = true
    //     this.dtOptions.page = 1
    //     this.loadProjects()
    //   }
    //   if (this.customIdToSearch.length < 1) {
    //     this.loading = true
    //     this.dtOptions.page = 1
    //     this.loadProjects()
    //   }
    // },
    // operatorIdToSearch() {
    //   this.loading = true
    //   this.loadProjects()
    // },
    // statusToSearch() {
    //   this.loading = true
    //   this.loadProjects()
    // },
    // annoDiRiferimento() {
    //   if (this.annoDiRiferimento.length >= 4 || this.annoDiRiferimento.length === 0) {
    //     this.loading = true
    //     this.loadProjects()
    //   }
    // },
    yearFromUrl() {
      this.loading = true
      this.loadProjects()
    },
    showProjectDialog(newVal, oldVal) {
      if (!newVal) {
        this.clone = false
      }
      if (oldVal && !newVal) {
        this.loadProjects()
      }
    },
    // excludeSecondary() {
    //   this.loading = true
    //   this.loadProjects()
    // }
  },
  mounted() {
    // Imposta l'anno corrente come filtro predefinito
    if (!this.yearFromUrl && !this.annoDiRiferimento) {
      const currentYear = new Date().getFullYear();
      this.annoDiRiferimento = currentYear.toString();
    }

    // Carica i progetti UNA VOLTA sola
    this.loadProjects();

    // Disabilita il flag di inizializzazione dopo il primo caricamento
    this.$nextTick(() => {
      this.isInitializing = false;
    });

    // Controlla se siamo in una route di dettaglio progetto
    if (this.$route.name === 'detailsProject' && this.$route.params.projectId) {
      // Apri la modale di dettaglio
      this.selectedProjectId = this.$route.params.projectId;
      this.showProjectDetailModal = true;
    }
  },
  methods: {
    resetFilters() {
      this.customerToSearch = '';
      this.customIdToSearch = '';
      this.projectToSearch = '';
      this.selectedCustomerId = null; // Resetta anche l'ID del cliente selezionato
      this.operatorIdToSearch = '';
      this.statusToSearch = '';
      // Imposta l'anno corrente invece di lasciarlo vuoto
      this.annoDiRiferimento = new Date().getFullYear().toString();
      this.filterForAlert = '';
      this.excludeSecondary = '';

      // Dopo aver resettato i filtri, carichiamo i progetti
      this.loadProjects();
    },

    applyFilters() {
      // Carichiamo i progetti con i filtri correnti usando il metodo filtrato
      this.filterLoading = true;
      this.loadProjectsFiltered();
    },

    // Verifica se ci sono filtri attivi
    hasActiveFilters() {
      const currentYear = new Date().getFullYear().toString();

      return (
        this.customerToSearch !== '' ||
        this.customIdToSearch !== '' ||
        this.projectToSearch !== '' ||
        this.operatorIdToSearch !== '' ||
        this.statusToSearch !== '' ||
        (this.annoDiRiferimento !== '' && this.annoDiRiferimento !== currentYear) ||
        this.filterForAlert !== '' ||
        this.excludeSecondary !== ''
      );
    },

    getColor(anno) {
      if (anno === 2000) return 'error'
      else if (anno === 2021) return 'primary'
      else if (anno === 2022) return 'success'
      else if (anno === 2023) return 'error'
    },

    getColorClass(anno) {
      if (anno === 2000) return 'error--text'
      else if (anno === 2021) return 'primary--text'
      else if (anno === 2022) return 'success--text'
      else if (anno === 2023) return 'error--text'
      else return 'grey--text'
    },

    getRowClass(item) {
      // Se l'ID dell'item è uguale all'ID espanso, aggiungi la classe 'expanded-parent'
      return this.expanded === item.id ? 'expanded-parent' : ''
    },

    // Metodo debounce per filtrare con un ritardo
    debounceFilter() {
      this.filterLoading = true;
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.loadProjectsFiltered();
      }, 500); // Ritardo di 500ms
    },

    // Metodo per gestire la selezione dell'insegna
    onCustomerSelect(value) {
      console.log('Customer selected:', value);

      // Salva l'ID del cliente selezionato
      this.selectedCustomerId = value;

      // Ottieni il nome del cliente selezionato
      if (value) {
        // Carica i dettagli del cliente selezionato
        this.$customerService.get(value)
          .then(response => {
            // Imposta il nome del cliente come valore di ricerca
            this.customerToSearch = response.data.name;
            console.log('Customer name:', this.customerToSearch);
            this.debounceFilter();
          })
          .catch(error => {
            console.error('Error loading customer details:', error);
            this.customerToSearch = value;
            this.debounceFilter();
          });
      } else {
        // Se il valore è null, imposta il valore di ricerca a null
        this.customerToSearch = null;
        this.debounceFilter();
      }
    },

    // Metodo per caricare i progetti filtrati senza mostrare il loader grande
    loadProjectsFiltered() {
      // Impostiamo this.loading = true per mostrare il timer
      this.loading = true;
      this.startLoadingTimer();
      const params = {
        page: this.dtOptions.page || 1,
        page_size: this.dtOptions.itemsPerPage || 10,
        ...this.ordering,
      };

      if (this.customerToSearch) {
        // Utilizziamo il parametro corretto per il filtro insegna
        params.customer = this.customerToSearch;
      }

      if (this.customIdToSearch) {
        params.custom_id__icontains = this.customIdToSearch;
      }

      if (this.projectToSearch) {
        params.name__icontains = this.projectToSearch;
      }

      if (this.operatorIdToSearch) {
        params.operator = this.operatorIdToSearch;
      }

      if (this.statusToSearch) {
        params.product_status = this.statusToSearch;
      }

      // Se è specificato un anno nei filtri, usalo
      if (this.annoDiRiferimento) {
        params.anno_riferimento = this.annoDiRiferimento;
      }
      // Altrimenti, se è specificato un anno nell'URL, usalo
      else if (this.yearFromUrl) {
        params.anno_riferimento = this.yearFromUrl;
      }
      // Se non è specificato alcun anno, usa l'anno corrente
      else {
        params.anno_riferimento = new Date().getFullYear().toString();
      }

      if (this.filterForAlert) {
        params.show_alert = this.filterForAlert;
      }

      if (this.excludeSecondary) {
        params.exclude_secondary = this.excludeSecondary;
      }

      // Aggiungiamo sempre il parametro is_backup
      params.is_backup = this.isBackup;

      console.log('Filtering projects with anno_riferimento:', params.anno_riferimento);

      this.$projectService.list(params)
        .then(resp => {
          this.projects = resp.data.results;
          this.projectsCount = resp.data.count;
          this.filterLoading = false; // Disattiva l'indicatore di caricamento dei filtri
          this.loading = false; // Disattiva anche il loader grande
          this.stopLoadingTimer();
        })
        .catch(err => {
          console.error(err);
          this.filterLoading = false; // Disattiva l'indicatore di caricamento dei filtri in caso di errore
          this.loading = false; // Disattiva anche il loader grande in caso di errore
          this.stopLoadingTimer();
        });
    },
    initialOperator(full_name) {
      let names = full_name.split(' '),
          initials = names[0].substring(0, 1).toUpperCase();

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      return initials;
    },
    filterDetail(detailAlert) {
      return detailAlert.filter(items =>
          items.expired === true &&
          items.status !== 'LAVOROCHIUSO' &&
          items.status !== 'INVALFORNITORE'
      )
    },
    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    closeAll() {
      this.expandedClose = []
    },
    loadDetails(item) {
      this.expanded = item.item.id
    },
    formatDate(isoDate) {
      return moment(isoDate).format('DD/MMM/YYYY')
      //moment.locale('it')
      //return format(parseISO(isoDate).toLocaleDateString('it'), 'dd/MMM/yyyy')
    },
    loadProjects() {
      // Un solo indicatore di loading
      this.loading = true
      this.startLoadingTimer();

      // Se non è specificato un anno, usa l'anno corrente
      let annoRiferimento = this.yearFromUrl ? this.yearFromUrl : this.annoDiRiferimento;
      if (!annoRiferimento) {
        annoRiferimento = new Date().getFullYear().toString();
      }

      const params = {
        page: this.dtOptions.page || 1,
        page_size: this.dtOptions.itemsPerPage || 10,
        ...this.ordering,
        custom_id__icontains: this.customIdToSearch,
        customer: this.customerToSearch,
        anno_riferimento: annoRiferimento,
        operator: this.operatorIdToSearch,
        product_status: this.statusToSearch,
        name__icontains: this.projectToSearch,
        show_alert: this.filterForAlert,
        is_backup: this.isBackup,
        exclude_secondary: this.excludeSecondary
      }

      console.log('Loading projects with anno_riferimento:', params.anno_riferimento);

      ProjectService.list(params).then(
          response => {
            this.projects = response.data.results;
            this.projectsCount = response.data.count
            this.loading = false
            this.stopLoadingTimer();
            this.filterLoading = false // Disattiva l'indicatore di caricamento dei filtri
            this.closeAll()
          }
      ).catch(error => {
          console.error('Errore nel caricamento progetti:', error);
          this.loading = false;  // Assicuriamoci di rimuovere il loading anche in caso di errore
          this.stopLoadingTimer();
          this.filterLoading = false;
      })
    },
    addProject() {
      this.selectedProjectId = null
      this.showProjectDialog = true
    },
    openProjectDetail(item) {
      this.selectedProjectId = item.id;
      this.showProjectDetailModal = true;

      // Aggiorniamo l'URL per mantenere la navigazione, ma senza ricaricare la pagina
      this.$router.push({
        name: 'detailsProject',
        params: { projectId: item.id },
      }, () => {}, // Callback vuoto per success
      () => {}); // Callback vuoto per error (ignoriamo gli errori di navigazione)
    },
    cloneProject(item) {
      this.$projectService.clone(item.id).then(
          resp => {
            this.showProjectDialog = true
            this.$dtoast.pop({preset: "success", content: 'Progetto clonato'})
            this.selectedProjectId = resp.data.id
            this.clone = true
          }
      )
    },
    editProject(item) {
      this.selectedProjectId = item.id
      this.showProjectDialog = true
    },
    deleteProject(item) {
      this.projectIdToDelete = item.id
      this.showProjectDeleteDialog = true
    },
    openInfoAlert(item) {
      this.detailAlert = Object.values(item.show_alert)
      this.openAlert = true
    },
    ensureUserInStore() {
      if (!this.$store.state.user) {
        return this.$store.dispatch('setCurrentUser');
      } else {
        return Promise.resolve();
      }
    },



    updateItemsPerPage(itemsPerPage) {
      console.log('Updating items per page to:', itemsPerPage);
      // Mostriamo il loader grande centrale quando si cambia il numero di elementi per pagina
      this.loading = true;
      this.startLoadingTimer();

      // Forziamo un ritardo per assicurarci che l'utente veda il loading
      setTimeout(() => {
        // Aggiorniamo direttamente i parametri e carichiamo i progetti
        const params = {
          page: 1, // Reset to page 1 when changing items per page
          page_size: itemsPerPage,
          ...this.ordering,
          custom_id__icontains: this.customIdToSearch,
          customer: this.customerToSearch,
          anno_riferimento: this.yearFromUrl ? this.yearFromUrl : (this.annoDiRiferimento || new Date().getFullYear().toString()),
          operator: this.operatorIdToSearch,
          product_status: this.statusToSearch,
          name__icontains: this.projectToSearch,
          show_alert: this.filterForAlert,
          is_backup: this.isBackup,
          exclude_secondary: this.excludeSecondary
        };

        // Blocca il watcher temporaneamente
        this.isInitializing = true;

        // Aggiorniamo dtOptions per mantenere la sincronizzazione con la tabella
        this.dtOptions = {
          ...this.dtOptions,
          itemsPerPage: itemsPerPage,
          page: 1
        };

        // Riabilita il watcher
        this.$nextTick(() => {
          this.isInitializing = false;
        });

        // Carichiamo i progetti direttamente invece di affidarci al watcher
        console.log('Sending request with params:', params);
        this.$projectService.list(params)
          .then(response => {
            this.projects = response.data.results;
            this.projectsCount = response.data.count;
            this.loading = false;
            this.stopLoadingTimer();
            this.progress = false;
            this.filterLoading = false;
            this.closeAll();
            console.log(`Loaded ${response.data.results.length} projects with ${itemsPerPage} items per page`);
            console.log('Response data:', response.data);
          })
          .catch(err => {
            console.error('Error loading projects:', err);
            this.loading = false;
            this.stopLoadingTimer();
            this.progress = false;
            this.filterLoading = false;
          });
      }, 300); // Breve ritardo per assicurarci che l'utente veda il loading
    },

    // Metodo per gestire il cambio di pagina
    onPageChanging(isChanging) {
      if (isChanging) {
        // Mostriamo il loader grande centrale quando si cambia pagina
        this.loading = true;
        this.startLoadingTimer();

        // Forziamo un ritardo per assicurarci che l'utente veda il loading
        setTimeout(() => {
          // Carichiamo i progetti direttamente senza triggeare il watcher
          const params = {
            page: this.dtOptions.page || 1,
            page_size: this.dtOptions.itemsPerPage || 50,
            ...this.ordering,
            custom_id__icontains: this.customIdToSearch,
            customer: this.customerToSearch,
            anno_riferimento: this.yearFromUrl ? this.yearFromUrl : (this.annoDiRiferimento || new Date().getFullYear().toString()),
            operator: this.operatorIdToSearch,
            product_status: this.statusToSearch,
            name__icontains: this.projectToSearch,
            show_alert: this.filterForAlert,
            is_backup: this.isBackup,
            exclude_secondary: this.excludeSecondary
          };

          console.log('Sending request with params:', params);
          this.$projectService.list(params)
            .then(response => {
              this.projects = response.data.results;
              this.projectsCount = response.data.count;
              this.loading = false;
              this.stopLoadingTimer();
              this.progress = false;
              this.filterLoading = false;
              this.closeAll();
              console.log(`Loaded ${response.data.results.length} projects on page ${this.dtOptions.page}`);
              console.log('Response data:', response.data);
            })
            .catch(err => {
              console.error('Error loading projects:', err);
              this.loading = false;
              this.stopLoadingTimer();
              this.progress = false;
              this.filterLoading = false;
            });
        }, 300); // Breve ritardo per assicurarci che l'utente veda il loading

        // Manteniamo anche il timeout di sicurezza
        setTimeout(() => {
          if (this.loading) {
            console.log('Loading timeout reached, forcing loading to false');
            this.loading = false;
            this.stopLoadingTimer();
          }
        }, 5000); // 5 secondi di timeout
      }
    },

    // Loading timer methods
    startLoadingTimer() {
      this.loadingStartTime = Date.now();
      this.loadingTime = "0.00s";

      this.loadingTimer = setInterval(() => {
        const elapsed = (Date.now() - this.loadingStartTime) / 1000;
        this.loadingTime = elapsed.toFixed(2) + "s";
      }, 50);
    },

    stopLoadingTimer() {
      if (this.loadingTimer) {
        clearInterval(this.loadingTimer);
        this.loadingTimer = null;
      }
      if (this.loadingStartTime) {
        const elapsed = (Date.now() - this.loadingStartTime) / 1000;
        this.loadingTime = elapsed.toFixed(2) + "s";
      }
    }
  },
}
</script>

<style>

.project.COMPLETE {
  border-left: 4px solid #3cd1c2;
}

.project.WIP {
  border-left: 4px solid orange;
}

.project.waiting {
  border-left: 4px solid tomato;
}

.v-chip.ongoing {
  background: #3cd1c2;
}

.v-chip.complete {
  color: orange;
}

.v-chip.waiting {
  color: tomato;
}

.my_class td {
  font-size: 12px !important;
  height: 100px !important;
}

/* Stili per le colonne personalizzate */
.alert-column {
  max-width: 40px !important;
  width: 40px !important;
  padding: 0 !important;
}

.referente-column {
  max-width: 70px !important;
  width: 70px !important;
  padding: 0 !important;
}

.insegna-column {
  max-width: 140px !important;
  width: 140px !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  line-height: 1.2 !important;
}

.insegna-text {
  font-size: 13px !important;
  line-height: 1.2 !important;
  max-height: 32px !important;
  white-space: normal !important;
  overflow: visible !important;
  display: block !important;
}

.cid-column {
  max-width: 100px !important;
  width: 100px !important;
}

.cid-text {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  font-size: 13px !important;
}

.anno-column {
  max-width: 80px !important;
  width: 80px !important;
  text-align: center !important;
  padding: 0 4px !important;
}

.anno-text {
  font-size: 13px !important;
  font-weight: 500 !important;
  display: block !important;
  text-align: center !important;
}

.actions-column {
  min-width: 170px !important;
  max-width: 170px !important;
  width: 170px !important;
  padding-left: 8px !important;
}

/* Stile per il chip dei referenti */
.ref-chip {
  width: 30px !important;
  height: 24px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  font-size: 12px !important;
  padding: 0 !important;
  min-width: 30px !important;
  text-align: center !important;
}

.progetto-column {
  min-width: 200px !important;
  max-width: 300px !important;
  width: 25% !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

/* Stili per le date */
.date-column-from, .date-column-to {
  min-width: 120px !important;
  max-width: 120px !important;
  width: 120px !important;
  padding-right: 4px !important;
  text-align: center !important;
}

.date-column-from {
  background-color: rgba(25, 118, 210, 0.03) !important; /* Sfondo leggermente colorato per le colonne "Da" */
}

.date-column-to {
  background-color: rgba(0, 0, 0, 0.01) !important; /* Sfondo leggermente colorato per le colonne "A" */
}

.date-chip {
  margin: 0 !important;
  height: 22px !important;
  font-size: 11px !important;
  min-width: 90px !important;
  max-width: 100px !important;
  padding: 0 6px !important;
  display: inline-flex !important;
  justify-content: center !important;
}

.date-empty {
  font-size: 14px !important;
  color: rgba(0, 0, 0, 0.4) !important;
  display: block !important;
  text-align: center !important;
  font-weight: 500 !important;
}

/* Stile per l'header Alert con icona */
.alert-column .v-data-table__wrapper th:first-child {
  position: relative;
}

.alert-column .v-data-table__wrapper th:first-child:before {
  content: "\F009C"; /* Codice icona campanella (mdi-bell) */
  font-family: "Material Design Icons";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 18px;
  color: rgba(0, 0, 0, 0.6);
}

/* Stile per le azioni */
.table-actions {
  display: flex;
  justify-content: flex-end;
  gap: 2px;
  padding-right: 4px;
  min-width: 160px;
}

/* Assicuriamoci che le icone delle azioni abbiano spazio sufficiente */
.table-actions .v-btn.v-btn--icon.v-size--x-small {
  margin: 0 !important;
  width: 24px !important;
  height: 24px !important;
}

/* Stile per la tabella responsive */
.v-data-table {
  table-layout: fixed !important;
  width: 100% !important;
}

.v-data-table__wrapper {
  overflow-x: auto !important;
}

/* Stili per migliorare la spaziatura e distribuzione dei filtri */
.filter-row {
  margin: 0 -8px !important; /* Compensa il padding delle colonne */
}

.filter-row .v-col {
  padding: 8px 12px !important; /* Aumenta la spaziatura orizzontale */
}

/* Le colonne dei filtri occupano tutto lo spazio disponibile */
.filter-row .v-col {
  flex: 1 1 0 !important; /* Crescita uguale per tutte le colonne */
}

/* I componenti di input occupano tutta la larghezza della colonna */
.filter-row .v-input {
  width: 100% !important;
}

/* Assicura che il testo nelle select non venga troncato */
.filter-row >>> .v-select__selections {
  max-width: 100% !important;
  overflow: visible !important;
}

.filter-row >>> .v-select__selection {
  max-width: 100% !important;
  overflow: visible !important;
  white-space: nowrap !important;
}

/* Rimuove i bordi dalle select quando sono focalizzate/selezionate - Approccio aggressivo */
.filter-row .v-input--is-focused,
.filter-row .v-input--is-focused .v-input__slot,
.filter-row .v-input--is-focused >>> .v-input__slot,
.filter-row .v-select--is-focused,
.filter-row .v-select--is-focused .v-input__slot,
.filter-row .v-select--is-focused >>> .v-input__slot,
.filter-row .v-autocomplete--is-focused,
.filter-row .v-autocomplete--is-focused .v-input__slot,
.filter-row .v-autocomplete--is-focused >>> .v-input__slot {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  outline: none !important;
  background: transparent !important;
}

/* Rimuove tutti i possibili effetti di focus */
.filter-row .v-input:focus,
.filter-row .v-input:focus-within,
.filter-row .v-select:focus,
.filter-row .v-select:focus-within,
.filter-row .v-autocomplete:focus,
.filter-row .v-autocomplete:focus-within {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Rimuove bordi da tutti gli elementi interni */
.filter-row >>> .v-input__slot,
.filter-row >>> .v-field,
.filter-row >>> .v-field__field,
.filter-row >>> .v-field__outline,
.filter-row >>> .v-field__outline__start,
.filter-row >>> .v-field__outline__notch,
.filter-row >>> .v-field__outline__end {
  border: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Forza la rimozione di tutti i bordi colorati */
.filter-row >>> .v-input--is-focused .v-input__slot,
.filter-row >>> .v-input--is-focused .v-field,
.filter-row >>> .v-input--is-focused .v-field__field,
.filter-row >>> .v-input--is-focused .v-field__outline {
  border-color: rgba(0, 0, 0, 0.12) !important;
  border-width: 1px !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
}

/* Stili per evidenziare la riga espansa */
.v-data-table >>> tr.expanded-parent {
  background-color: rgba(25, 118, 210, 0.08) !important; /* Sfondo blu molto chiaro */
  border-left: 4px solid var(--v-primary-base) !important; /* Bordo sinistro colorato */
  position: relative !important;
  transition: all 0.3s ease !important;
}

.v-data-table >>> tr.expanded-parent:hover {
  background-color: rgba(25, 118, 210, 0.12) !important; /* Sfondo leggermente più scuro al hover */
}

.v-data-table >>> tr.expanded-parent td {
  border-bottom: 1px solid rgba(25, 118, 210, 0.2) !important; /* Bordo inferiore colorato */
}

/* Stile per la sezione dei dettagli espansa */
.v-data-table >>> tr.v-data-table__expanded.v-data-table__expanded__content {
  background-color: #f8fafe !important; /* Sfondo molto chiaro per i dettagli */
  border-left: 4px solid var(--v-primary-base) !important; /* Continua il bordo sinistro */
  transition: all 0.3s ease !important;
}

.v-data-table >>> tr.v-data-table__expanded.v-data-table__expanded__content td {
  border-bottom: 1px solid rgba(25, 118, 210, 0.1) !important;
  padding: 0 !important;
}

/* Container per la riga espansa */
.expanded-row-container {
  padding: 0 !important;
  background-color: #f8fafe !important;
  border-left: 4px solid var(--v-primary-base) !important;
}

/* Separatore visivo tra riga principale e contenuto espanso */
.expanded-separator {
  height: 2px;
  background: linear-gradient(90deg, var(--v-primary-base) 0%, rgba(25, 118, 210, 0.3) 50%, transparent 100%);
  margin: 0;
}

/* Header della sezione espansa */
.expanded-header {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.05) 0%, rgba(25, 118, 210, 0.02) 100%);
  padding: 12px 20px;
  border-bottom: 1px solid rgba(25, 118, 210, 0.1);
  display: flex;
  align-items: center;
  font-size: 0.95rem;
}

/* Card di dettaglio migliorata */
.detail-card-improved {
  background-color: white !important;
  margin: 0 !important;
  border-radius: 0 0 8px 8px !important;
  overflow: hidden;
}

/* Stile per la card di dettaglio (legacy) */
.detail-card {
  background-color: white !important;
  border-radius: 8px !important;
  margin: 8px 16px 16px 16px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid rgba(25, 118, 210, 0.15) !important;
}

/* Stile per la colonna di espansione */
.expand-column {
  min-width: 50px !important;
  max-width: 50px !important;
  width: 50px !important;
  padding: 0 12px !important;
  text-align: center !important;
}

/* Stile per il pulsante di espansione */
.v-data-table >>> .expand-column .v-data-table__expand-icon {
  margin: 8px !important;
  padding: 4px !important;
}

.v-data-table >>> .expand-column .v-btn {
  margin: 4px !important;
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
}

/* Migliora la visibilità della tabella interna */
.detail-card-improved >>> .detail-table {
  border-radius: 0 !important;
}

.detail-card-improved >>> .detail-table .v-data-table__wrapper {
  border-radius: 0 !important;
}

/* Header della tabella interna più visibile */
.detail-card-improved >>> .detail-table thead th {
  background-color: rgba(25, 118, 210, 0.04) !important;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
  font-weight: 600 !important;
  padding: 12px 16px !important;
}

/* Prima riga della tabella interna con spazio */
.detail-card-improved >>> .detail-table tbody tr:first-child td {
  padding-top: 12px !important;
  border-top: 1px solid rgba(0, 0, 0, 0.05) !important;
}

/* ALLINEAMENTO VERTICALE CENTRATO - TABELLA DETTAGLI PROGETTO */
.detail-card-improved >>> .v-data-table tbody td {
  vertical-align: middle !important;
  padding: 12px 16px !important;
}

.detail-card-improved >>> .v-data-table thead th {
  vertical-align: middle !important;
}

.detail-card-improved >>> .v-data-table .v-data-table__wrapper tbody tr td {
  vertical-align: middle !important;
  height: auto !important;
  min-height: 48px !important;
}

.detail-card-improved >>> .v-data-table .v-data-table__wrapper tbody tr {
  height: auto !important;
}

/* Forza l'allineamento per tutti gli elementi interni */
.detail-card-improved >>> .v-data-table td > * {
  display: flex !important;
  align-items: center !important;
  min-height: 32px !important;
}

.detail-card-improved >>> .v-data-table td .v-input {
  margin: 0 !important;
  padding: 0 !important;
}

.detail-card-improved >>> .v-data-table td .v-select {
  margin: 0 !important;
  padding: 0 !important;
}

.detail-card-improved >>> .v-data-table td .v-chip {
  margin: 2px !important;
}

/* Loading timer discreto */
.discrete-loader {
  position: fixed;
  top: 80px;
  right: 24px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  border-radius: 20px;
  padding: 8px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  z-index: 999;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.discrete-loader .text-caption {
  color: #666;
  font-size: 11px;
  font-weight: 500;
}
</style>

